<template>
  <div class="page-content">
    <page-template
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
    ></page-template>
  </div>
</template>
<script>
  import pageTemplate from "@/components/template/pageTemplate";
  import formDialog from "@/components/template/formDialog";
  import api from "@/config/api";

  export default {
    components: {
      formDialog,
      pageTemplate,
    },
    data() {
      return {
        dialogVisibility: false,
        // 高级搜索条件
        searchOptions: {
          simple: [{label: "门店名称", prop: "name", type: "input", ifFuzzy: true, placeholder: "请输入门店名称"}]
        },
        // 更多功能
        toolConfig: [
          {
            label: "续费",
            code: 'update',
            type: this.$utils.buttonType.tableOperate
          }
        ],
        // 表格信息配置
        tableOptions: {
          indexShow: true,//是否显示索引
          columns: [
            {
              label: "门店编码",
              prop: "loginName",
              width: "120",
              align: "center"
            },
            {label: "门店名称", prop: "name", width: "120", align: "center"},
            {
              label: "状态",
              prop: "descr",
              width: "120",
              align: "center",
              data: this.$utils.getCacheStatus('esbService.type')
            },
            {
              label: "有效日期",
              prop: "descr",
              width: "120",
              align: "center",
            }
          ],
          url: api.system.account
        },
      };
    },
    methods: {}
  };
</script>




// WEBPACK FOOTER //
// src/page/system/renewal/Mgmt.vue